import { render, staticRenderFns } from "./videoItem.vue?vue&type=template&id=6ed11784&scoped=true&"
import script from "./videoItem.vue?vue&type=script&lang=js&"
export * from "./videoItem.vue?vue&type=script&lang=js&"
import style0 from "./videoItem.vue?vue&type=style&index=0&id=6ed11784&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed11784",
  null
  
)

export default component.exports